import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Campaign } from '@feathr/blackbox';
import { CardV2 as Card, Input } from '@feathr/components';

interface IProps {
  campaign: Campaign;
}

function CreativeDefaultSettings({ campaign }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Card width={'full'}>
      <Card.Header
        description={t('Configure default settings for all creatives in this set.')}
        title={t('Creative Default Settings')}
      />
      <Card.Content addVerticalGap={true}>
        <Input
          attribute={'destination_url'}
          helpText={t('This URL will be used for all creatives unless overridden individually.')}
          label={t('Destination URL')}
          model={campaign}
          placeholder={'https://example.com/landingpage?utm_campaign=feathr'}
          required={true}
          type={'url'}
        />
        <Input
          attribute={'alt_text'}
          helpText={t(
            'Alternative text with a clear call-to-action for cases where the image cannot load and for screen readers.',
          )}
          label={t('Alt text')}
          model={campaign}
          optional={true}
          type={'text'}
        />
      </Card.Content>
    </Card>
  );
}

export default observer(CreativeDefaultSettings);
